import { render } from "./PhotoCarousel.vue?vue&type=template&id=9e01ca0c&scoped=true"
import script from "./PhotoCarousel.vue?vue&type=script&lang=js"
export * from "./PhotoCarousel.vue?vue&type=script&lang=js"

import "./photo-carousel.scss?vue&type=style&index=0&id=9e01ca0c&lang=scss&scoped=true"

import exportComponent from "/home/user/AIF_Orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e01ca0c"]])

export default __exports__